module.exports = __webpack_public_path__ + "img/notifications--avatar.63cf84d5.svg";